<template>
  <div id="app">
    <FloatBall :text="'<< 返回'" v-if="thirdRedirectUrl" @click.native="doGoBack" ></FloatBall>
    <router-view />
  </div>
</template>

<script>
import config from "./utils/config";

window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};

import { post } from "@/api/index.js";
import { getUrlKey } from "@/utils";
import FloatBall from '@/components/FloatBall';

export default {
  name: "App",
  data() {
    return {
      thirdRedirectUrl: "",
    };
  },
  watch: {},
  beforeCreate() {
    document.addEventListener(
      "plusready",
      function () {
        let uuid = plus.device.uuid;
      },
      false
    );
  },
  components: {
    FloatBall
  },
  mounted() {
    try {
      this.thirdRedirectUrl = sessionStorage.getItem("thirdRedirectUrl");
      console.log("thirdRedirectUrl", this.thirdRedirectUrl);
    } catch (e) {
      console.log(e);
    }
    this.isMobile();
  },
  created() {
    //   let path = window.location.href.split("?") //分割url
    //   console.log(path,'测试截取Url')
    //   if (path[1]) {
    //     let href = path[0]+"?"+path[1]
    //     console.log(href,'herif测试四')
    // 　　let urlData  = getUrlKey("mchtId",href)
    //     console.log(urlData,'urlData疯狂开发')
    //     sessionStorage.setItem("mchtId",urlData);
    //   }

  },
  methods: {
    doGoBack() {
      if (this.thirdRedirectUrl) {
        location.href = this.thirdRedirectUrl;
      }
    },
    isMobile() {
      //判断数组中是否包含某字符串
      Array.prototype.contains = function (needle) {
        for (i in this) {
          if (this[i].indexOf(needle) > 0) return i;
        }
        return -1;
      };

      var device_type = navigator.userAgent; //获取userAgent信息
      // alert(device_type,''); //打印到页面
      var md = new MobileDetect(device_type); //初始化mobile-detect
      var os = md.os(); //获取系统
      // alert(os, "型号");
      var model = "";
      if (os == "iOS") {
        //ios系统的处理
        os = md.os() + md.version("iPhone");
        model = md.mobile();
      } else if (os == "AndroidOS") {
        //Android系统的处理
        os = md.os() + md.version("Android");
        var sss = device_type.split(";");
        var i = sss.contains("Build/");
        if (i > -1) {
          model = sss[i].substring(0, sss[i].indexOf("Build/"));
        }
      }

        sessionStorage.setItem("Edition", os);
        sessionStorage.setItem("Model", model);
      // alert(os + "版本号---" + model + "型号---"); //打印系统版本和手机型号
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

<style >
.nut-textinput input {
  font-size: 26px !important;
  font-family: MicrosoftYaHei !important;
  font-weight: 400 !important;
}
.nut-textinput input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: rgba(153, 153, 153, 1) !important;
}
.nut-textinput input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(153, 153, 153, 1) !important;
}
.nut-textinput input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(153, 153, 153, 1) !important;
}
.nut-textinput input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: rgba(153, 153, 153, 1) !important;
}
.nut-infiniteloading .bottom-tips .tips-txt {
  color: #321 !important;
}
.nut-infiniteloading .bottom-tips .loading-txt {
  color: #321 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue